import React from 'react';
import { Link } from 'react-router-dom';
import sponsorchurchPartner from "../../assests/sponsorchurchpartner.jpg";
import sponsorteacher from "../../assests/sponsorteacher.jpg";

function SponsorshipProgramme() {
  const sponsors = [
    {
      no: "#1",
      title: "Sponsor a Child",
      color: "#2d8b57",
      image: "",
      video: "https://www.youtube.com/embed/r4EVM3zpCoE",

      text:
        "Christ For India takes care of hundreds of children on a daily basis through the Nava Jeevan Children's Home. Your sponsorship provides food, clothing, education and healthcare.",

      question: "Would you consider sponsoring a child?",

      gift:
        "Your gift will provide lodging, meals, healthcare and education.",

      donate:
        "To support a child, you can give $40 monthly.",

      sponsorUrl:
        "https://www.paypal.com/donate/?hosted_button_id=SARBARXK6BRK6",
    },

    {
      no: "#2",
      title: "Sponsor a Seminary Student",
      color: "#ff8c42",
      image: "",
      video: "https://www.youtube.com/embed/6fH15mSPzxQ",

      text:
        "Help equip a student to obtain theological training so they can become pastors and evangelists throughout India.",

      question:
        "Would you consider sponsoring a seminary student?",

      gift:
        "Your gift will provide lodging, meals, healthcare and education.",

      donate:
        "To support a student, you can give $50 monthly.",

      sponsorUrl:
        "https://www.paypal.com/donate/?hosted_button_id=VKA8FX7X6AJG2",
    },

    {
      no: "#3",
      title: "Sponsor a Church Planter",
      color: "#2d8b57",
      image: sponsorchurchPartner,
      video: "",

      text:
        "Many pastors are pioneering churches in unreached villages. Sponsorship enables them to continue serving Christ full-time.",

      question:
        "Would you consider sponsoring a native pastor and his family?",

      gift:
        "Your gift will provide rice and rent.",

      donate:
        "To support a native pastor and his family, you can give $50 or $100 monthly.",

      sponsorUrl:
        "https://www.paypal.com/donate/?hosted_button_id=V7C9GVAEMJ2Z4",
    },

    {
      no: "#4",
      title: "Sponsor a Teacher",
      color: "#2d8b57",
      image: sponsorteacher,
      video: "",

      text:
        "Our campus teachers are dedicated to providing quality education for children in India.",

      question:
        "Would you consider sponsoring a teacher?",

      gift:
        "Your gift will help provide toward their salary.",

      donate:
        "To support a teacher, you can give $300 monthly.",

      sponsorUrl:
        "https://www.paypal.com/donate/?hosted_button_id=XWJXARQKMPGA8",
    },

    {
      no: "#5",
      title: "Sponsor a Seminary Faculty Member",
      color: "#ff8c42",
      image: "",
      video: "https://www.youtube.com/embed/IksPumr7pns",

      text:
        "Our faculty members are committed to equipping students to reach the lost in India.",

      question:
        "Would you consider sponsoring a seminary faculty member?",

      gift:
        "Your gift will help provide toward their salary.",

      donate:
        "To support a faculty member, you can give $500 monthly.",

      sponsorUrl:
        "https://www.paypal.com/donate/?hosted_button_id=Q3GBRJ7KY373C",
    },

    {
      no: "#6",
      title: "Sponsor a Medical Doctor or Nurse",
      color: "#2d8b57",
      image: "",
      video: "https://www.youtube.com/embed/ODUEZUtfA30",

      text:
        "Our medical staff provides free first aid and consultation to people on campus and in surrounding villages.",

      question:
        "Would you consider sponsoring a medical doctor and/or nurse?",

      gift:
        "Your gift will help provide toward their salary.",

      donate:
        "Sponsor a Medical Doctor: $400/month | Sponsor a Nurse: $125/month",

      doctorUrl:
        "https://www.paypal.com/donate/?hosted_button_id=A6QSS4B93DZK6",

      nurseUrl:
        "https://www.paypal.com/donate/?hosted_button_id=BWT28RB9DKHRJ",
    },
  ];

  return (
    <div
      style={{
        fontFamily: "'Georgia','Times New Roman',serif",
        background: "#fff",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          padding: "20px",
        }}
      >
        {/* Back */}
        <Link
          to="/"
          style={{
            color: "#c47a1e",
            textDecoration: "none",
            display: "inline-block",
            fontSize: 13,
          }}
        >
          ← Back to Home
        </Link>

        {/* Sponsorship Cards */}
        {sponsors.map((item, index) => (
          <div key={index}>
            {index !== 0 && (
              <div
                style={{
                  textAlign: "center",
                  color: "#999",
                  margin: "20px 0",
                  letterSpacing: "4px",
                }}
              >
                • • • • • • • •
              </div>
            )}

            {/* Card Heading */}
            <h3
              style={{
                textAlign: "center",
                color: item.color,
                marginBottom: "20px",
              }}
            >
              {item.no} {item.title.toUpperCase()}
            </h3>

            {/* Card Content */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "30px",
                alignItems: "center",
                marginBottom: "30px",
              }}
            >
              {/* Image / Video */}
              <div
                style={{
                  flex: 1,
                  minWidth: "320px",
                }}
              >
                {item.video ? (
                  <iframe
                    width="100%"
                    height="250"
                    src={item.video}
                    title={item.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      border: "none",
                      borderRadius: "4px",
                    }}
                  />
                ) : (
                  <img
                    src={item.image}
                    alt={item.title}
                    style={{
                      width: "100%",
                      maxWidth: "420px",
                      height: "250px",
                      objectFit: "cover",
                    }}
                  />
                )}
              </div>

              {/* Text */}
              <div
                style={{
                  flex: 1,
                  minWidth: "280px",
                }}
              >
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.8",
                  }}
                >
                  {item.text}
                </p>

                <h3
                  style={{
                    color: item.color,
                  }}
                >
                  {item.question}
                </h3>

                <p>{item.gift}</p>
              </div>
            </div>

            {/* Donation Banner */}
            <div
              style={{
                background: item.color,
                color: "#fff",
                textAlign: "center",
                padding: "35px 20px",
                marginBottom: "20px",
              }}
            >
              <h2>{item.title}</h2>

              <p>{item.donate}</p>

              {/* Medical Doctor / Nurse */}
              {item.no === "#6" ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "15px",
                    flexWrap: "wrap",
                    marginTop: "15px",
                  }}
                >
                  {/* Doctor */}
                  <a
                    href={item.doctorUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      background: "transparent",
                      color: "#fff",
                      border: "2px solid #fff",
                      padding: "10px 28px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      textDecoration: "none",
                    }}
                  >
                    SPONSOR A DOCTOR
                  </a>

                  {/* Nurse */}
                  <a
                    href={item.nurseUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      background: "transparent",
                      color: "#fff",
                      border: "2px solid #fff",
                      padding: "10px 28px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      textDecoration: "none",
                    }}
                  >
                    SPONSOR A NURSE
                  </a>
                </div>
              ) : (
                /* Other Sponsor Buttons */
                <a
                  href={item.sponsorUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    marginTop: "10px",
                    background: "transparent",
                    color: "#fff",
                    border: "2px solid #fff",
                    padding: "10px 28px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    textDecoration: "none",
                  }}
                >
                  SPONSOR
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SponsorshipProgramme;
